import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import useTranslation from '../hooks/useTranslation';
import './NotFound.css';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="notfound">
      <div className="notfound__bg" aria-hidden="true" />
      <div className="container notfound__content">
        <motion.div
          className="notfound__logo"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
        </motion.div>
        <motion.h1
          className="notfound__title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {t('notFound.title')}
        </motion.h1>
        <motion.p
          className="notfound__subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {t('notFound.subtitle')}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <Link to="/" className="btn-accent notfound__btn">
            {t('notFound.backHome')}
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
